import {http} from '@/helpers/http-helper';

class Client {
    constructor(
        uuid,
        name,
        surname,
        sex,
        birthday,
        email,
        emails,
        phone,
        phones,
        nif,
        address
    ) {
        this.uuid = uuid;
        this.name = name;
        this.surname = surname;
        this.sex = sex;
        this.birthday = birthday;
        this.email = email;
        this.emails = emails;
        this.phone = phone;
        this.phones = phones;
        this.nif = nif;
        this.address = address;
    }
}

class Activity {
    constructor(type, date, username, description) {
        this.type = type;
        this.date = date;
        this.username = username;
        this.description = description;
    }
}

export const getClientActivity = (clientId) => {
    return new Promise((resolve, reject) => {
        const url = 'clients/' + clientId + '/activity';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {

                    let activities = [];

                    response.data.forEach((activity) => {
                        activities.push(new Activity(
                            activity.type,
                            new Date(activity.registeredAt),
                            activity.username,
                            activity.description
                        ));
                    });

                    resolve(activities);

                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const createClientAttachment = (clientId, attachment) => {
    return new Promise((resolve, reject) => {
        const url = 'clients/' + clientId + '/attachment';

        let formData = new FormData();
        formData.append('attachment', attachment);

        http.post(url, formData)
            .then((response) => {
                if (response.status === 201) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const deleteClientAttachment = (clientId, attachmentId) => {
    return new Promise((resolve, reject) => {
        const url = 'clients/' + clientId + '/attachments/' + attachmentId;
        http.delete(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const searchClients = (filters, page, itemsPerPage) => {
    let requestPage = page | 1;
    let requestItemsPerPage = itemsPerPage | 1;
    return new Promise((resolve, reject) => {
        const url = 'clients/search';
        http.post(url, filters, {page: requestPage, itemsPerPage: requestItemsPerPage})
            .then((response) => {
                if (response.status === 200 && !!response.data.clients) {
                    resolve(response.data.clients);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const createClient = (client) => {
    return new Promise((resolve, reject) => {
        const url = 'clients';
        http.post(url, client)
            .then((response) => {
                if (response.status === 201) {
                    resolve(new Client(
                       response.data.uuid,
                       response.data.name,
                       response.data.surname,
                       response.data.sex,
                       response.data.birthday,
                       response.data.email,
                       response.data.phones
                    ));
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getClient = (clientId) => {
    return new Promise((resolve, reject) => {
        const url = 'clients/' + clientId;
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(new Client(
                        response.data.uuid,
                        response.data.name,
                        response.data.surname,
                        response.data.sex,
                        response.data.birthday,
                        response.data.email,
                        response.data.emails,
                        response.data.phone,
                        response.data.phones,
                        response.data.nif,
                        response.data.address
                    ));
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const unsubscribeClient = (requestObject) => {
  return new Promise( (resolve, reject) => {
    const url = 'public/client/unsubscribe';
    http.post(url, requestObject.data)
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
